import IJobCandidateInteractionDTO from '../types/IJobCandidateInteractionDTO';

const calculateCredits = (processedCandidates: IJobCandidateInteractionDTO[], message: string) => {
  const creditMap: { [key: string]: number } = {
    '1': 1,
    '61': 30,
  };
  const validCandidates = processedCandidates.filter(
    (processedCandidate) => processedCandidate.isValid
  );
  let totalCreditsNeeded = 0;
  let shortestSms = message.replace(
    '{{CANDIDATE_NAME}}',
    validCandidates[0]?.name ?? 'CANDIDATE_NAME'
  ).length;
  let longestSms = shortestSms;
  validCandidates.map((validCandidate) => {
    const characterCount = message.replace(
      '{{CANDIDATE_NAME}}',
      validCandidate?.name ?? 'CANDIDATE_NAME'
    ).length;
    if (characterCount < shortestSms) {
      shortestSms = characterCount;
    } else if (characterCount > longestSms) {
      longestSms = characterCount;
    }
    totalCreditsNeeded +=
      Math.ceil(characterCount / 150) * creditMap[validCandidate.countryCallingCode];
  });

  return [shortestSms, longestSms, totalCreditsNeeded];
};

export default calculateCredits;
